export default [
  {
    path: "/bantuan-ternak/",
    component: () => import("@/pages/bantuan-ternak/bantuan-ternak-list.vue"),
    meta: { title: "Daftar Bantuan Ternak" },
  },
  {
    path: "/bantuan-ternak/create",
    component: () => import("@/pages/bantuan-ternak/bantuan-ternak-form.vue"),
    meta: { title: "Tambah Bantuan Ternak" },
  },
  {
    path: "/bantuan-ternak/edit/:id",
    component: () => import("@/pages/bantuan-ternak/bantuan-ternak-edit.vue"),
    meta: { title: "Edit Bantuan Ternak" },
  },
  {
    path: "/bantuan-ternak/detail/:id",
    component: () => import("@/pages/bantuan-ternak/bantuan-ternak-detail.vue"),
    meta: { title: "Detail Bantuan Ternak" },
  },
  {
    path: "/bantuan-ternak/import",
    component: () => import("@/pages/bantuan-ternak/bantuan-ternak-import.vue"),
    meta: { title: "Import Bantuan Ternak" },
  },
];
